import ErrorText from 'core/modules/atoms/ErrorText';
import { InputCheckbox, InputPassword } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import FormField from 'ui/molecules/FormField/FormField';
import InputText from 'ui/atoms/InputText/InputText';

const AccountForm = ({ t, onChange, error, onAcceptTerms, onOpenTerms, user }) => {
  return (
    <div className="account-form">
      <div className="account-form__field">
        <FormField error={!!error.name} errorMessage={error['name']}>
          <InputText
            //disabled={user.identity_provider}
            placeholder={t('Name')}
            onChange={onChange}
            name="name"
            value={user.name || ''}
          />
        </FormField>
      </div>

      <div className="account-form__field">
        <FormField error={!!error.surname} errorMessage={error['surname']}>
          <InputText
            //disabled={user.identity_provider}
            placeholder={t('Surname')}
            onChange={onChange}
            name="surname"
            value={user.surname || ''}
          />
        </FormField>
      </div>

      <div className="account-form__field">
        <FormField error={!!error.email} errorMessage={error['email']}>
          <InputText
            disabled={user.identity_provider}
            autoComplete="off"
            iconLeft={true}
            placeholder={t('signup:Email')}
            onChange={onChange}
            name="email"
            icon="email"
            value={user.email || ''}
          />
        </FormField>
      </div>
      {!user.identity_provider && (
        <>
          <div className="account-form__field">
            <FormField error={!!error.confirmEmail} errorMessage={error['confirmEmail']}>
              <InputText
                disabled={user.identity_provider}
                autoComplete="off"
                iconLeft={true}
                placeholder={t('signup:Confirm Email')}
                onChange={onChange}
                name="confirmEmail"
                icon="email"
                value={user.confirmEmail || ''}
              />
            </FormField>
          </div>
          <div className="account-form__field">
            <FormField error={!!error.password} errorMessage={error['password']}>
              <InputPassword
                autoComplete="off"
                placeholder={t('Password', { count: 3 })}
                onChange={onChange}
                name="password"
                value={user.password || ''}
              />
            </FormField>
          </div>
          <div className="account-form__field">
            <FormField error={!!error.confirmPassword} errorMessage={error['confirmPassword']}>
              <InputPassword
                autoComplete="off"
                placeholder={t('signup:Confirm password', { count: 3 })}
                onChange={onChange}
                name="confirmPassword"
                value={user.confirmPassword || ''}
              />
            </FormField>
          </div>
        </>
      )}
      <div className="account-form__field">
        <InputCheckbox
          name="accept"
          onChange={onAcceptTerms}
          checked={user.terms}
          label={
            <a>
              {t('signup:I’ve read and accept')}
              <a
                href="/terms"
                target="_blank"
                className="account-form__terms"
                aria-label={t('buttons:Go to read terms and conditions')}
                title={t('buttons:Go to read terms and conditions')}
              >
                {' '}
                {t('signup:terms and conditions')}
              </a>
            </a>
          }
        />
        {error.terms && <ErrorText text={error['terms']} />}
      </div>
    </div>
  );
};

AccountForm.propTypes = {
  error: PropTypes.object,
};

AccountForm.defaultProps = {
  error: {},
  onOpenTerms: () => {},
};

export default withTranslation(['profile', 'signup', 'placeholder'])(AccountForm);
